var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"c2023-why"}},[_c('b-container',{staticClass:"px-md-0"},[_c('b-row',{staticClass:"justify-content-end justify-content-md-center"},[_c('b-col',{attrs:{"lg":"9"}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('c2023.why.title'))}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('c2023.why.desc'))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }